import { IconArtboard, IconBuildingStadium, IconChartArrowsVertical, IconCodeCircle2Filled, IconCurrencyRupee, IconMessageChatbotFilled } from '@tabler/icons-react'
import React from 'react'
import { DashboardCardWrapper } from "../../commonComponents/DashboardCardWrapper"

export const RevenueByCategory = () => {

    const revenueCategoryData = [
        {
            label: "Consulting",
            amount: "450",
            percentage: "30",
            icon: <IconBuildingStadium color='#f94b00' />
        },
        {
            label: "Designing",
            amount: "370",
            percentage: "83",
            icon: <IconArtboard color='#6624ff' />
        },
        {
            label: "Development",
            amount: "310",
            percentage: "54",
            icon: <IconCodeCircle2Filled color='#027ffd' />
        },
        {
            label: "Support",
            amount: "289",
            percentage: "72",
            icon: <IconMessageChatbotFilled color='#05ad9f' />
        },
        {
            label: "Training",
            amount: "165",
            percentage: "26",
            icon: <IconChartArrowsVertical color='#ff1899' />
        },
    ]

    const categoryGradients = [
        'linear-gradient(90deg, rgba(99,102,241,0.18) 0%, rgba(99,102,241,0) 100%)',
        'linear-gradient(90deg, rgba(16,185,129,0.18) 0%, rgba(16,185,129,0) 100%)',
        'linear-gradient(90deg, rgba(245,158,11,0.18) 0%, rgba(245,158,11,0) 100%)',
        'linear-gradient(90deg, rgba(236,72,153,0.18) 0%, rgba(236,72,153,0) 100%)',
        'linear-gradient(90deg, rgba(6,182,212,0.18) 0%, rgba(6,182,212,0) 100%)',
    ]

    return (
        <DashboardCardWrapper
            headerText={"Revenue By Category"}
            componentStyles={{ width: "35%" }}
        >
            <div className='d-flex flex-column gap-3 mt-2'>
                {revenueCategoryData.map((item, index) => (
                    <CategoryCard
                        key={item.label}
                        {...item}
                        gradient={categoryGradients[index]}
                    />
                ))}
            </div>
        </DashboardCardWrapper>
    )
}

const CategoryCard = ({ label, amount, percentage, icon, gradient }) => {
    return (
        <div
            className='d-flex align-items-center justify-content-between p-2 rounded-3'
            style={{ background: gradient }}
        >
            <div className='d-flex align-items-center gap-2'>
                <span
                    className='p-1 border-0 shadow-sm rounded-2'
                    style={{ background: 'white' }}
                >
                    {icon}
                </span>
                <div className='d-flex flex-column gap-1 justify-content-start'>
                    <span className='fw-semibold fs-14'>{label}</span>
                    <span className='fs-13 fw-medium '>{percentage}%</span>
                </div>
            </div>
            <span className='d-flex align-items-center fw-bold'><IconCurrencyRupee size={20} />{amount}</span>
        </div>
    )
}